export enum ThresholdType {
  Alert = 'alert',
  Warn = 'warning',
}
